import { useCanQueryTenantData, useIsOnboardingRoute } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";
import { useSyncPrimaryTenant } from "../../hooks/useSyncPrimaryTenant.ts";
import { BulkProvider } from "../remediation/BulkProvider.tsx";

function TenantGatedBulkProvider({ children }: PropsWithChildren) {
    const canQueryTenantData = useCanQueryTenantData();
    // Skipped on onboarding pages: until setup's page clears the stored tenant, a request here sends the tenant setup
    // is replacing, and a 403 on it sends the user to the zero state.
    const isOnboardingRoute = useIsOnboardingRoute();

    return <BulkProvider shouldSkip={!canQueryTenantData || isOnboardingRoute}>{children}</BulkProvider>;
}

/**
 * Inside the layout's `mainContent`, around `ModuleGates`: providers that fetch.
 * See .claude/rules/providers-and-gates.md.
 */
export function ModuleDataProviders({ children }: PropsWithChildren) {
    useSyncPrimaryTenant();

    return <TenantGatedBulkProvider>{children}</TenantGatedBulkProvider>;
}
